module.exports = __webpack_public_path__ + "img/temp-logo-with-title.53431076.png";